(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-animation"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ca_wrap-mob .swiper-wrapper > *').forEach((el) => {
    el.classList.add('swiper-slide');
  });

  var swiper = new Swiper('.ca_wrap-mob', {
    slidesPerView: 2,
    spaceBetween: 20,

    breakpoints: {
      0: {
        slidesPerView: 1.15,
        spaceBetween: 15,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  window.addEventListener('resize', () => {
    swiper.update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["career-opportunity-section"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.main-co-popup .poup-close').forEach(function(el) {
  el.addEventListener('click', function() {
    this.closest('.main-co-popup').classList.remove('active');
  });
});

document.querySelectorAll('.main-ci .inner-ci .learn-more').forEach(function(el) {
  el.addEventListener('click', function(e) {
    const att_val = this.getAttribute('data-id');
    document.querySelectorAll('.section-career-opportunity .main-co-popup').forEach(function(popup) {
      if (popup.getAttribute('data-id') === att_val) {
        document
          .querySelectorAll('.section-career-opportunity .main-co-popup')
          .forEach(p => p.classList.remove('active'));
        popup.classList.add('active');
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form-with-marquee"] && !Shopify.designMode) return;
  try {
    
    function updateContactHeight() {
        const formTitle = document.querySelector('.contact-form__title');
        const contactImages = document.querySelector('.contact-images');
        
        if (formTitle && contactImages) {
            const formHeight = formTitle.offsetHeight;
            contactImages.style.height = `${formHeight}px`;
        }
    }

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    }

    document.addEventListener('DOMContentLoaded', function () {
        // Initial call (catches static content)
        updateContactHeight();

        // Watch for Globo form to finish injecting its content
        const formContainer = document.querySelector('.globo-formbuilder');
        if (formContainer) {
            const observer = new MutationObserver(debounce(function() {
                updateContactHeight();
            }, 300));

            observer.observe(formContainer, {
                childList: true,
                subtree: true
            });
        }

        // Fallback: re-check a few times after load in case observer misses final paint
        [500, 1000, 2000, 3500].forEach(function(delay) {
            setTimeout(updateContactHeight, delay);
        });
    });

    // Run on resize
    window.addEventListener('resize', debounce(updateContactHeight, 250));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.project-categories--list li').forEach(cat => {
      cat.addEventListener('click', function() {
        const selected = this.getAttribute('value');
        
        document.querySelectorAll('.project-categories--list li').forEach(c => c.classList.remove('active'));
        this.classList.add('active');
        
        document.querySelectorAll('.project-list__item').forEach(project => {
          const show = selected === 'all' || project.dataset.category === selected;
          project.style.display = show ? '' : 'none';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
